// 土耳其语

export default {
  t1: 'Tamamla',
  t5: 'Öde',
  t6: 'Bağla ve yetkilendir',
}
